export interface Testimonial {
  quote: string
  name: string
  city: string
}

export const testimonials: Testimonial[] = [
  {
    quote: '«Era esattamente quello che mi mancava. Ora entro in sala con la lezione già scritta.»',
    name: 'Chiara M.',
    city: 'Milano',
  },
  {
    quote: '«Le schede illustrate sono bellissime. Le mie allieve le portano a casa e le usano davvero.»',
    name: 'Valentina R.',
    city: 'Bologna',
  },
  {
    quote: '«Con le progressioni su tre livelli gestisco finalmente una classe mista senza ansia.»',
    name: 'Giulia F.',
    city: 'Torino',
  },
  {
    quote: '«Ho ridotto la preparazione da un’ora a cinque minuti. Per me è tempo restituito.»',
    name: 'Marta B.',
    city: 'Firenze',
  },
  {
    quote: '«Le indicazioni sulle molle sono precise: le uso anche per formare le nuove istruttrici.»',
    name: 'Elena T.',
    city: 'Padova',
  },
  {
    quote: '«Lo studio dove insegno ha stampato i poster e ora la sala sembra molto più professionale.»',
    name: 'Sara D.',
    city: 'Roma',
  },
]
